import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Tooltip } from "~/components/Tooltip";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const PEG_MAINTENANCE_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.pegMaintenanceDescription,
    sortsOn: AssetColumns.pegMaintenanceDescription,
    label: "Peg Maintenance Description",
    tooltip: CatalogReferenceDataSlugs.peg_maintenance_description,
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        if (!item.isAsset) {
            return <Emdash />;
        }

        const value = item.peg_maintenance_description;
        if (!value) {
            return <Emdash />;
        }

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="px-3 py-2 text-sm max-w-sm whitespace-pre-line">
                        {value}
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span ref={setTriggerRef} className="line-clamp-2">
                        {value}
                    </span>
                )}
            </Tooltip>
        );
    },
};
